import type { Locale } from '@/lib/locale'

const APARAT_DEMO_URL = 'https://www.aparat.com/v/prb0522?refererRef=channel_page'

/** Locale-specific hero demo video URLs. `null` hides the Watch Demo button. */
export const MARKETING_DEMO_VIDEO_URLS: Partial<Record<Locale, string | null>> = {
  fa: APARAT_DEMO_URL,
  en: null, // TODO: add English demo URL (e.g. YouTube) when available
}

export function getMarketingDemoVideoUrl(locale: string): string | null {
  const url = MARKETING_DEMO_VIDEO_URLS[locale as Locale]
  return url ?? null
}
